import React from 'react';
import PT from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import SVG from 'react-inlinesvg';
import crownIcon from '@lifesize/ux-assets/vectors/svgIcons/crown.svg';
import classes from './UpgradeButton.module.scss';

export class UpgradeButton extends React.PureComponent {
  render() {
    if (!this.props.showUpgrade) return null;
    return (
      <button
        className={classes.button}
        data-testid="upgradeButton"
        onClick={this.props.sendToShop}
      >
        <SVG src={crownIcon} />
        <FormattedMessage id="components.upgradeButton.label" description="Upgrade Label" defaultMessage="Upgrade Plan" />
      </button>
    );
  }
}

UpgradeButton.propTypes = {
  intl: PT.object.isRequired,
  sendToShop: PT.func.isRequired,
  showUpgrade: PT.bool
};

export default injectIntl(UpgradeButton);
